// Left as a JS file as the IDE / ESList was complaining about the import
import {Address} from "address-rfc2821";

/**
 * Validates a single email address string.
 *
 * @param address {string} The email address to validate
 * @returns {boolean} true if the string was a valid email address, false if not
 */
export function validateSingleEmailAddress(address) {
    if (!address || address.trim().length === 0) {
        return false;
    }
    try {
        const a = new Address(address);
        return !a.isNull();
    } catch (_error) {
        return false;
    }
}
